<template>
  <div>
    <Pane v-if="!inModal" :title="editId ? '重新提交采购申请' : '采购申请'" />

    <div :class="{ container: !inModal }">
      <a-form
        :form="form"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 12 }"
        :colon="false"
        @submit="handleSubmit"
      >
        <a-row>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item>
              <span class="required" slot="label">申请人</span>
              <a-input :value="showApplicant" disabled />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item>
              <span class="required" slot="label">申请部门</span>
              <a-input :value="showDepartment" disabled />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="申请日期">
              <a-date-picker
                v-if="!isDetail"
                style="width: 100%"
                v-decorator="[
                  'applyDate',
                  { rules: [{ required: true, message: '请选择！' }] },
                ]"
              />
              <a-input v-else :value="detailData.applyDate" disabled />
            </a-form-item>
          </a-col>
        </a-row>

        <div class="between">
          <div class="title">采购申请清单</div>
          <div v-if="!isDetail" style="display: flex; justify-content: flex-end; gap: 10px">
            <AddMaterial @add="add" :canEdit="true" />
          </div>
        </div>

        <a-table
          bordered
          :dataSource="list"
          :pagination="false"
          :columns="columns"
        >
          <template slot="price" slot-scope="text">
            <span style="color: #1890ff">{{ text }}</span>
          </template>
          <template slot="amount" slot-scope="text, record">
            <a-input-number v-if="!isDetail" :min="1" :max="99999999" v-model.number="record.amount" />
            <span v-else>{{ text || record.num || record.count || '—' }}</span>
          </template>
          <template slot="action" slot-scope="text, record, index">
            <a href="#" class="danger" @click.prevent="remove(index)">移除</a>
          </template>
        </a-table>

        <div class="center">
          <a-space>
            <a-button v-if="!isDetail" htmlType="submit" type="primary" :loading="loading">{{ editId ? '重新提交' : '提交' }}</a-button>
            <a-button @click="handleClose">关闭</a-button>
          </a-space>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import AddMaterial from "./components/add-material-input.vue";
import { addOfficeApply, fetchOfficeDetail, resubmitOfficeApply } from "@/api/oa/purchaseMaterials";
import moment from "moment";
export default {
  components: { AddMaterial },

  props: {
    inModal: { type: Boolean, default: false },
    detailData: { type: Object, default: null },
  },

  data() {
    return {
      form: this.$form.createForm(this),
      list: [],
      loading: false,
      editId: null,
    };
  },

  computed: {
    ...mapState("auth", ["user"]),
    ...mapGetters("auth", ["department"]),
    isDetail() {
      return !!this.detailData;
    },
    showApplicant() {
      if (this.detailData) return this.detailData.applicantName;
      return this.user.userName;
    },
    showDepartment() {
      if (this.detailData) return this.detailData.departmentName;
      return this.department.deptUniqueName;
    },
    columns() {
      const cols = [
        { title: "分类", dataIndex: "category" },
        { title: "商品名称", dataIndex: "name" },
        { title: "规格型号", dataIndex: "spec" },
        { title: "颜色", dataIndex: "color" },
        { title: "单位", dataIndex: "unit", align: "center" },
        { title: "单价(元)", dataIndex: "price", align: "center", scopedSlots: { customRender: "price" } },
        { title: "申领数量", dataIndex: "amount", align: "center", scopedSlots: { customRender: "amount" } },
        { title: "备注", dataIndex: "remark", ellipsis: true },
      ];
      if (!this.isDetail) {
        cols.push({ title: "操作", align: "center", width: 100, scopedSlots: { customRender: "action" } });
      }
      return cols;
    },
  },

  mounted() {
    if (this.detailData) {
      this.list = Array.isArray(this.detailData.subList)
        ? this.detailData.subList.map((item) => ({ ...item }))
        : [];
    } else if (this.$route.query.id) {
      this.editId = this.$route.query.id;
      this.loadDetail();
    } else {
      this.form.setFieldsValue({
        applyDate: moment(),
      });
    }
  },

  methods: {
    loadDetail() {
      fetchOfficeDetail(this.editId).then((res) => {
        if (res) {
          this.form.setFieldsValue({
            applyDate: res.applyDate ? moment(res.applyDate) : moment(),
          });
          this.list = Array.isArray(res.subList)
            ? res.subList
                .filter((item) => item && item.name)
                .map((item) => ({ ...item, amount: item.amount || item.count || item.num }))
            : [];
        }
      });
    },

    add(payload) {
      const index = this.list.findIndex((item) => item.id === payload.id);
      if (index === -1) {
        this.list.push(payload);
      } else {
        this.list.splice(index, 1, payload);
      }
    },

    remove(index) {
      this.list.splice(index, 1);
    },

    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.list.length === 0) {
            this.$message.error("请添加采购物料");
            return;
          }

          this.loading = true;
          const payload = {
            applicantId: this.user.uuid,
            applicantName: this.user.userName,
            departmentId: this.department.deptId,
            departmentName: this.department.deptUniqueName,
            applyDate: values.applyDate
              ? values.applyDate.format("YYYY-MM-DD")
              : "",
            subList: this.list.map((item) => ({
              name: item.name,
              spec: item.spec,
              color: item.color,
              unit: item.unit,
              price: item.price,
              count: item.amount,
              remark: item.remark,
              category: item.category,
            })),
          };

          const apiCall = this.editId
            ? resubmitOfficeApply({ ...payload, id: this.editId })
            : addOfficeApply(payload);

          apiCall
            .then(() => {
              this.$message.success("提交成功");
              this.$emit("success");
              this.handleClose();
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },

    handleClose() {
      if (this.inModal) {
        this.$emit("close");
      } else {
        this.$close(this.$route.path);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  background-color: #fff;
  padding: 24px 160px;
}
.title {
  margin-top: 30px;
  margin-bottom: 18px;
  font-size: 14px;
  font-weight: bold;
  line-height: 22px;
  color: #1890ff;
}
.center {
  margin-top: 80px;
}
.danger {
  color: #f5222d;
}
</style>
